import React, { Component } from 'react';
import { Modal } from 'antd';
import Spinner from 'react-spinkit';


class MeOverlayLoading extends Component {
    render() {
        const { containerStyle, messageStyle } = styles;

        return (
            <Modal
                visible={this.props.visible}
                wrapClassName="vertical-center-modal"
                footer={null}
                maskClosable={false}
                closable={false}
                width={320}
            >
                <div className="noselect" style={containerStyle}>
                    <Spinner name="folding-cube" color="#8FC30F" />
                    <label style={messageStyle}>{this.props.message}</label>
                </div>
            </Modal>
        );
    }
}

const styles = {
    containerStyle: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center'
    },
    messageStyle: {
        paddingTop: 24,
        marginBottom: 0
    }
}

export default MeOverlayLoading;



// WEBPACK FOOTER //
// ./src/components/MeOverlayLoading.jsx